export const VERIFICATION_STATUS = {
  IN_PROGRESS: "in_progress",
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected"
}
